import { fetchHelper } from '../../api/api'
import { searchActions } from './searchSlice'

export const getResults = params => async dispatch => {
    dispatch(searchActions.getSearchResultsRequest())
    const url =
        params.type === 'class' ? 'Search/GetClasses' : 'Search/GetCourses'
    try {
        const response = await fetchHelper.get(url, {
            params: {
                ...params,
                pageSize: 10,
            },
        })
        let { data, paging } = response.data
        data = data.map(item => ({
            ...item,
            type: params.type,
        }))
        dispatch(searchActions.getSearchResultsRequestSuccess({ data, paging }))
    } catch (e) {
        console.error(e)
        dispatch(searchActions.getSearchResultsRequestError(e.message))
    }
}
